import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconShoppingCart } from '@redteclab/icons'

import { LoadingButton } from 'base-ui'

import {
  cartIntermediateAccessorGetRedPointsRedPointsAmountWithMultiplier,
  cartIntermediateAccessorGetSellerData,
  useProductAddToCart,
} from '../../../../../cart-intermediate'
import { experimentsCompeteraTrackCompeteraEvent } from '../../../../../experiments/competera-experiment/experimentsCompeteraTrackCompeteraEvent'
import { useExperimentsContext } from '../../../../../experiments/components/ExperimentsContext'
import {
  EXPERIMENTS_TRACK_EVENT_PDP_ADD_TO_CART_CTA,
  EXPERIMENTS_TRACK_EVENT_PDP_COMPETERA,
  experimentsTrackEvent,
} from '../../../../../experiments/eventTracking'
import { useGetExperimentForTenant } from '../../../../../experiments/hooks'
import { EXPERIMENT_HEADER_STICKY_TOGGLE } from '../../../../../experiments/model/EXPERIMENT_NAME_PER_TENANT'
import { experimentAccessorIsEnabled } from '../../../../../experiments/model/experimentAccessor'
import { useGlobalConfigContext } from '../../../../../global-config'
import { useProductPageContext } from '../../../productPageContext'
import { useBuildAddToCartParams } from '../../ProductAddToCartGroup/ProductAddToCartCta/useBuildAddToCartParams'

export const ProductBuyBoxStickyAddToCart: FC = () => {
  const { disableCta } = useBuildAddToCartParams()
  const { experiments } = useExperimentsContext()
  const globalConfig = useGlobalConfigContext()

  const headerStickyToggleExperiment = useGetExperimentForTenant(
    EXPERIMENT_HEADER_STICKY_TOGGLE,
  )
  const isHeaderStickyToggleExperiment = experimentAccessorIsEnabled(
    headerStickyToggleExperiment.name,
    experiments,
  )

  const {
    currentOffer,
    currentPrescriptionType,
    product,
    quantitySelectionControls: { quantity },
  } = useProductPageContext()

  const redpoints = currentOffer
    ? cartIntermediateAccessorGetRedPointsRedPointsAmountWithMultiplier(
        currentOffer,
      )
    : 0
  const sellerData = cartIntermediateAccessorGetSellerData(currentOffer)

  const { handleAddToCart, isMutating } = useProductAddToCart({
    currentPrescriptionType,
    offerId: currentOffer?.offerId,
    product,
    quantity,
    redpoints,
    sellerData,
  })

  return (
    <LoadingButton
      className="w-full"
      data-qa-id="add-to-cart-button-sticky"
      disabled={disableCta}
      loading={isMutating}
      loadingPosition="start"
      onClick={(): void => {
        void handleAddToCart()
        if (isHeaderStickyToggleExperiment) {
          experimentsTrackEvent(
            globalConfig,
            EXPERIMENTS_TRACK_EVENT_PDP_ADD_TO_CART_CTA,
          )
        }
        experimentsCompeteraTrackCompeteraEvent(
          experiments,
          globalConfig,
          EXPERIMENTS_TRACK_EVENT_PDP_COMPETERA,
        )
      }}
      startIcon={isMutating ? null : <IconShoppingCart />}
      type="button"
    >
      <FormattedMessage id="general.button.label.addToCart" />
    </LoadingButton>
  )
}
